import React, {Component} from 'react'
import {withStyles} from '@material-ui/core/styles'

// COMPONENTS
import AppBarInner from '../components/app-bar/AppBarInner'
import AppStepper from '../components/app-stepper'
import LeftNavigationDashboard from '../components/app-navigation/LeftNavigationDashboard'
import Wrapper from '../components/wrapper'
import SiteBox from '../components/site-box/'
import {LogoGa} from '../components/app-icon/Icons'
import CustomizeAll from '../components/сustomize-all/'
import GAform from '../components/app-form/GAform'
import {ButtonContained} from "../components/app-button/button";

const styles = theme => ({
  pageTemplate: {
    maxWidth: 1072,
    margin: '0 auto',
  },
  wizardRow: {
    padding: '0 24px',
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
  },
  wizardContent: {
    maxWidth: 630,
    width: '100%',
  },
  header: {
    padding: '15px 40px 6px 22px',
  },
  content: {
    padding: '0 40px 30px 22px',
  },
  finishBtn: {
    display: 'block',
    textDecoration: 'none',
    marginTop: 25,
    position: 'relative',
    left: 0,
    width: 160,
    '&::after': {
      content: '" "',
      position: 'absolute',
      bottom: '100%',
      left: 14,
      height: 25,
      width: 1,
      backgroundColor: 'rgba(136, 102, 255, 0.2)',
    },
  },
})

function getSteps() {
  return [
    `Аккаунт \nподтвержден`,
    'Сайт \nдобавлен',
    'Настройте \nGoogle Analytics \nдля отображения \nрасширенных \nотчетов',
    'Добавьте каналы \nдля сбора данных \nо расходах',
    'Подключение CRM\nсистемы',
    'Подключение\nколлтрекинга',
  ]
}

class GaUser extends Component {
  state = {
    activeStep: 2,
    isFetching: false,
    site: window.state.site,
    accounts: window.state.google_analytics_accounts,
    isCard: window.state.cardTest,
    errorMessage: window.state.errorMessage,
  }

  redirect = (nextUrl, status) => {
    if (status === 'ok') {
      location.href = nextUrl
    }
  }

  handleSubmit = values => {
    this.setState({
      isFetching: true,
    })

    const url = '/wizard/ga/settings'

    const json = response => {
      return response.json()
    }

    const status = response => {
      if (response.status >= 200 && response.status < 300) {
        return Promise.resolve(response)
      } else {
        return Promise.reject(new Error(response.statusText))
      }
    }

    fetch(url, {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        'X-CSRF-TOKEN': document
          .querySelector('meta[name="csrf-token"]')
          .getAttribute('content'),
      },
      body: JSON.stringify(values),
    })
      .then(status)
      .then(json)
      .then(({status, errorMessage, nextUrl}) => {

        if (status && status === 'error') {
          this.setState({
            isFetching: false,
            errorMessage: errorMessage,
          });
          return false;
        }

        this.timerId = setTimeout(() => this.redirect(nextUrl, status), 1000)
      })
      .catch((error) => {
        this.setState({isFetching: false});
        console.log('Request failed', error)
      })
  }

  componentWillUnmount() {
    clearTimeout(this.timerId)
  }

  render() {
    const {classes} = this.props
    const {site, accounts, isFetching, isCard} = this.state
    const steps = isCard ? getSteps() : getSteps().slice(0, -1)

    const account = accounts.filter(account => account.selected)

    const property =
      account && account.length
        ? account[0].web_properties.filter(property => property.selected)
        : null

    const view =
      property && property.length
        ? property[0].views.filter(view => view.selected)
        : null

    return (
      <div className={classes.pageTemplate}>
        <AppBarInner/>
        <CustomizeAll/>

        <div className={classes.wizardRow}>
          <LeftNavigationDashboard/>
          <div style={{width: 200, position: 'relative'}}>
            <AppStepper activeStep={this.state.activeStep} steps={steps}/>

            <a
              href="/wizard/site"
              className={classes.finishBtn}
            >
              <ButtonContained full={true} text="Назад"/>
            </a>
          </div>

            <div className={classes.wizardContent}>
              <SiteBox
                url={site.url}
                resource={site.name}
                gutterBottom={8}
                prevUrl={'/wizard/site'}
              />

              <Wrapper shadow={4}>
                <header className={classes.header}>
                  <LogoGa className={classes.logoGa}/>
                </header>

                <section className={classes.content}>
                  {this.state.errorMessage ? (
                    <p
                      style={{
                        paddingLeft: 32,
                        fontSize: 14,
                        color: 'red',
                        marginBottom: 36,
                      }}
                      dangerouslySetInnerHTML={{__html: this.state.errorMessage}}
                    >
                    </p>
                  ) : null}

                  <GAform
                    onSubmit={this.handleSubmit}
                    initialAccount={account}
                    isFetching={isFetching}
                    botFilteringEnabled={view && view.length && view[0].bot_filtering_enabled}
                    initialValues={
                      property && property.length && view && view.length && {
                        account: account[0].id,
                        web_property: property[0].id,
                        view: view[0].id,
                      } || {}
                    }
                  />
                </section>
              </Wrapper>
            </div>
          </div>
        </div>
        )
        }
        }

        export default withStyles(styles)(GaUser)
